import './style.scss';
import Button from '../common/button';
import PropTypes from "prop-types";
import LinkButton from "../common/linkButton";

const UserForm = (props) => {
  const {
    formTitle,
    formSubtitle,
    hideTitle,
    submitLabel,
    submitAction,
    cancelAction,
    children,
    disabled
  } = props;

  return (
    <form className='user-form'>
      <div className='form-header'>
        <div className={hideTitle ? 'sr-hide' : 'form-title'}>{formTitle}</div>
      </div>
      <div className='form-body'>
        <div className='form-items'>
          {formSubtitle && <div className='form-subtitle'>{formSubtitle}</div>}
          { children }
          <div className='form-buttons'>
            {cancelAction && <LinkButton label='Cancel' clickAction={cancelAction}/>}
            <Button label={submitLabel} action={submitAction} disabled={disabled}/>
          </div>
        </div>
      </div>
    </form>
  );
};

UserForm.propTypes = {
  formTitle: PropTypes.string.isRequired,
  formSubtitle: PropTypes.element,
  submitLabel: PropTypes.string.isRequired,
  submitAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func,
  children: PropTypes.array.isRequired,
  disabled: PropTypes.bool
}

export default UserForm;
